<div class="uk-height-large uk-inline uk-flex uk-flex-left uk-flex-middle uk-cover-container" appResponsiveCheck #resize="appResponsiveCheck">
<ng-container *ngIf="resize.responsiveCheck">
    <!-- for desktop -->
    <img src="{{images}}" alt="{{title}}" uk-cover />
</ng-container>
<ng-container *ngIf="!resize.responsiveCheck">
    <!-- for Mobile -->
    <img src="{{imagesMobile}}" alt="{{title}}" uk-cover />
</ng-container>
  <div class="uk-overlay-primary uk-position-cover"></div>
  <div class="uk-container +fullwidth uk-light">
    <h4>สาระน่ารู้</h4>
    <h2 class="header-divider uk-margin-remove-top">{{title}}</h2>
    <p class="uk-margin-remove-top">{{description}}</p>
  </div>
</div>
